<template>
    <div class="hd_box">
        <h3>轮播图配置</h3>
        <p class="desc">用于添加、编辑与删除轮播图信息</p>
    </div>
    <div class="box_container">
        <!-- 添加语言切换tabs -->
        <el-tabs v-model="currentLocale" @tab-change="handleLocaleChange">
            <el-tab-pane label="中文" name="zh-CN"></el-tab-pane>
            <el-tab-pane label="英语" name="en"></el-tab-pane>
        </el-tabs>
        
        <el-button type="primary" @click="dialogVisible = true; isadd = true;">添加轮播图</el-button>
        <el-table :data="tableData" style="width: 100%" height="700" v-loading="loading">
            <el-table-column prop="id" label="ID" align="center" />
            <el-table-column prop="page" label="轮播所属栏目" align="center" width="130">
                <template v-slot="{ row }">
                    <p>{{ row.page.name }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="image_url" label="轮播图" align="center" width="250">
                <template v-slot="{ row }">
                    <img :src="row.image_url" class="avatar" />
                </template>
            </el-table-column>
            <el-table-column prop="link_url" label="跳转链接地址" align="center" />
            <el-table-column prop="created_at" label="创建时间" align="center" />
            <el-table-column prop="is_show" label="是否显示" align="center">
                <template v-slot="{ row }">
                    <el-switch v-model="row.is_show" @change="switchUp(row)" />
                </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" fixed="right" width="250">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="editplan(scope.row)">编辑</el-button>
                    <el-button type="primary" size="small" @click="deleteBrand(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <el-dialog v-model="dialogVisible" title="轮播图配置" @close="reset(formLabelAlignRef)">
        <el-form label-position="left" label-width="auto" :model="formLabelAlign" :rules="Dramarules"
            ref="formLabelAlignRef">
            <el-form-item label="轮播图所属栏目" required prop="page_id">
                <el-select v-model="formLabelAlign.page_id" placeholder="Select" size="large" style="width: 240px">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="轮播图" prop="image_url">
                <el-upload class="avatar-uploader" :show-file-list="false" :http-request="beforeAvatarUpload"
                    name="image">
                    <img :src="formLabelAlign.image_url" v-if="formLabelAlign.image_url" class="avatar" />
                    <el-icon v-else class="avatar-uploader-icon">
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="轮播图跳转链接" prop="link_url">
                <el-input v-model="formLabelAlign.link_url" />
            </el-form-item>
            <el-form-item label="轮播图描述" prop="image_alt">
                <el-input v-model="formLabelAlign.image_alt" />
            </el-form-item>
            <el-form-item label="是否显示" prop="is_show">
                <el-switch v-model="formLabelAlign.is_show" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="reset(formLabelAlignRef)">取消</el-button>
                <el-button type="primary" @click="creatFilm(formLabelAlignRef)">
                    确认
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { Plus } from '@element-plus/icons-vue'
import { banNers, addbanNers, editbanNers, delbanNers } from '@/api/user.js'
import { getCurrentInstance, reactive, ref, onBeforeUnmount, shallowRef, onMounted } from 'vue'
import { getArticleList, createArticle, uploadImg, getplanList, upPlan, ticketPrice, ticketPricechange, priceInfo, FilmInfo } from '@/api/article.js'

const formLabelAlignRef = ref()
const planRef = ref()
const priceRef = ref()
let isadd = ref(true)
const dialogVisible = ref(false)
const planVisible = ref(false)
const addplanVisible = ref(false)
const priceVisible = ref(false)
// 添加loading状态
const loading = ref(false)
// 当前语言
const currentLocale = ref('zh-CN')

//剧目ID
let FilmID = ref(0)
//剧目表单
let formLabelAlign = ref({
    image_url: '',
    link_url: '',
    is_show: true,
    image_alt: '',
    page_id: 1,
    thumb_url: '',
    locale: 'zh-CN'
})

//剧目查询
const onSubmit = () => {
    console.log('我是查询')
}

let searchForm = reactive({})

//剧目表单规则
const Dramarules = reactive({
    link: [
        { required: true, message: '请输入跳转链接', trigger: 'blur' },
    ],
})

const options = reactive([
    {
        value: 5,
        label: '首页',
    },
    {
        value: 1,
        label: '跨境联盟',
    },
    {
        value: 2,
        label: '产品服务',
    },
    {
        value: 3,
        label: '行业资讯',
    },
    {
        value: 4,
        label: '合作加盟',
    },
])

//票价表单规则
const priceRules = reactive({
    price_1: [
        { required: true, message: '请输入金额', trigger: 'blur' },
    ],
    price_2: [
        { required: true, message: '请输入金额', trigger: 'blur' },
    ],
    price_3: [
        { required: true, message: '请输入金额', trigger: 'blur' },
    ],
    price_4: [
        { required: true, message: '请输入金额', trigger: 'blur' },
    ],
})

let tableData = ref([])
let plantableData = ref([])
let total = ref(0)
let currentPage = ref(1);

//语言切换处理函数
const handleLocaleChange = () => {
    getData();
}

//获取列表参数
const getData = () => {
    loading.value = true;
    banNers({ locale: currentLocale.value })
        .then(res => {
            tableData.value = res;
        })
        .finally(() => {
            loading.value = false;
        })
}

getData();

//新增剧目or编辑剧目
const creatFilm = async (formEl) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            let obj = {
                ...formLabelAlign.value,
                locale: currentLocale.value, // 确保携带当前语言
                thumb_url: formLabelAlign.value.image_url
            };
            
            if (isadd.value) {
                addbanNers(obj)
                    .then(res => {
                        console.log(res)
                        ElMessage.success('新增成功')
                        reset(formEl)
                        getData();
                    })
            } else {
                editbanNers(obj)
                    .then(res => {
                        console.log(res)
                        ElMessage.success('编辑成功')
                        reset(formEl)
                        getData();
                    })
            }
        } else {
            console.log('error submit!', fields)
        }
    })
}

const switchUp = (row) => {
    let data = {
        id: row.id,
        is_show: row.is_show,
        locale: currentLocale.value // 添加locale参数
    }
    editbanNers(data)
        .then(res => {
            console.log(res)
            ElMessage.success('操作成功')
            getData();
        })
}

const reset = (formEl) => {
    formLabelAlign.value = {
        image_url: '',
        link_url: '',
        is_show: true,
        image_alt: '',
        page_id: 1,
        thumb_url: '',
        locale: currentLocale.value // 使用当前语言
    };
    dialogVisible.value = false;
}

//删除品牌图片
const deleteBrand = (row) => {
    //删除索引为index的数据
    delbanNers({ 
        id: row.id,
        locale: currentLocale.value // 添加locale参数
    })
        .then(res => {
            console.log(res)
            ElMessage.success('删除成功')
            getData();
        })
}

//图片上传
const beforeAvatarUpload = (option) => {
    console.log(option);
    let data = new FormData();
    data.append('image', option.file);
    uploadImg(data)
        .then(res => {
            ElMessage.success('上传成功');
            formLabelAlign.value.image_url = res.url;
            console.log(res)
        })
}

const editplan = (row) => {
    isadd.value = false;
    formLabelAlign.value = {
        ...row,
        locale: currentLocale.value // 设置当前语言
    };
    dialogVisible.value = true;
}
</script>

<style lang="scss" scoped>
.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}

.avatar {
    width: 160px;
    height: 100px;
}

.threehidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all
}

.avator {
    width: 140px;
}

.hd_box {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px #eee;
    padding: 10px 30px;
}

h3 {
    margin-bottom: 20px;
}

.desc {
    color: #aaa;
    font-size: 14px;
}

.box_container {
    margin-top: 30px;
    background-color: white;
    border-radius: 10px;
    box-shadow: #eee;
    padding: 10px 30px;

    .flex {
        display: flex;
        align-items: center;
        width: 200px;
        justify-content: space-between;
        margin: auto;
    }
}

// 添加tabs样式
:deep(.el-tabs) {
    margin-bottom: 20px;
}
</style>